import { useContext, useMemo } from 'react';
import { CompanyAuthContext } from '@contexts/company-auth-context/company-auth-context';
import { FeatureFlagContext } from '@contexts/feature-flag/feature-flag-context';
import { useTokenManagement } from '@hooks/auth/use-token-management';

import type { UseIsProtectedElementProps } from './use-is-protected-element.type';

export const useIsProtectedElement = ({ permissions, checkEveryPermission = true }: UseIsProtectedElementProps) => {
  const { isCompanyAuthEnabled } = useContext(FeatureFlagContext);
  const { permissions: contextPermissions } = useContext(CompanyAuthContext);
  const { getIsAdmin } = useTokenManagement();

  const isVisible = useMemo(
    () =>
      checkEveryPermission
        ? permissions?.every((permission) => contextPermissions?.includes(permission))
        : permissions?.some((permission) => contextPermissions?.includes(permission)),
    [permissions, checkEveryPermission, contextPermissions]
  );

  return isCompanyAuthEnabled && !getIsAdmin() ? isVisible : true;
};
